define('views/shop/instore/instore_preview',[
    'views/_base/baseview',
    'text!views/shop/instore/instore_preview.html',
    'views/shop/instore/merchant',
    'views/shop/instore/merchants_see_all_btn'
], function (BaseView, Template, MerchantView, SeeMerchantsBtnView) {
    'use strict';

    return BaseView.extend({
        id          : 'shop-instore-ul-container',
        className   : 'slider-inner-container',
        tagName     : 'div',
        isRender    : true,
        limit       : 10,
        counter     : 0,
        enable_delay: 2000,
        template    : _.template(Template),
        events      : {},
        initialize  : function(options){
            options = options || {};

            this.merchants = options.collection;

            this.shop_view = options.calling_view;

            this.counter = 0;

            // TODO: Finsih abstracting slider functionality into it's own component
            // this.slider = new Slider();

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            // console.log('Instore preview',this.merchants, this.merchants.length);

            // Note: this setTimeout is a temporary patch until we figure out the double firing of merchant search on the home page
            setTimeout(function(){

                if(_.isArray(that.merchants.models)){

                    that.merchants.models.forEach(that.addOne, that);

                }

            }, 700);

        },

        addOne: function(merchant){
            var that = this;

            if(this.counter < this.limit){

                var merchant = new MerchantView({ data: merchant, className: 'slider-item' });
                this.$el.find('#shop-instore-list-container').append(merchant.el);

                this.counter++;

            } else if(this.counter == this.limit){

                var see_all_merchants_btn = new SeeMerchantsBtnView({ className: 'slider-item', shop_view: this.shop_view });
                this.$el.find('#shop-instore-list-container').append(see_all_merchants_btn.el);
                this.counter++;

            } else if(this.counter == (this.limit + 1)){

                this.$el.find('#shop-instore-list-container').append('<li class="slider-item padding">&#160;</li>');
                this.counter++;

                setTimeout(function(){
                    that.shop_view.enablePreviewSlider();
                },this.enable_delay);

            } else {
                // TODO: Break out of loop
            }

        },

        close: function(){}
    });
});

